import { useEffect, useState } from 'react'
import { listAuditLog, type AuditRow } from '../api/admin'
import { fmtDateTime } from '../lib/format'

const COLS = '160px 220px 200px 1fr 120px'

export function Audit() {
  const [rows, setRows] = useState<AuditRow[] | null>(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    listAuditLog(100)
      .then(setRows)
      .catch((e) => setErr(e instanceof Error ? e.message : 'Could not load audit log'))
  }, [])

  return (
    <div className="page">
      <div className="ph">
        <div>
          <h1>Audit log</h1>
          <div className="desc">Who did what — logins, user and role changes, credential and MFA resets.</div>
        </div>
      </div>

      {err && <div className="auth-error mt8">{err}</div>}

      <div className="tbl tbl-scroll">
        <div className="tr head" style={{ gridTemplateColumns: COLS }}>
          <div>When</div>
          <div>Actor</div>
          <div>Action</div>
          <div>Detail</div>
          <div>IP</div>
        </div>
        {rows === null &&
          [0, 1, 2, 3, 4].map((i) => (
            <div className="tr body" style={{ gridTemplateColumns: COLS }} key={i}>
              <div className="skeleton" style={{ width: '80%' }} />
              <div className="skeleton" style={{ width: '70%' }} />
              <div className="skeleton" style={{ width: '60%' }} />
              <div className="skeleton" style={{ width: '50%' }} />
              <div className="skeleton" style={{ width: '60%' }} />
            </div>
          ))}
        {rows?.map((a) => (
          <div className="tr body" style={{ gridTemplateColumns: COLS }} key={a.id}>
            <div className="mono" style={{ fontSize: 11.5, color: 'var(--text-2)' }}>{fmtDateTime(a.at)}</div>
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.actor_email || '—'}</div>
            <div className="mono" style={{ fontSize: 11.5 }}>{a.action}</div>
            <div className="muted" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.detail || '—'}</div>
            <div className="mono" style={{ fontSize: 11.5, color: 'var(--text-3)' }}>{a.ip || '—'}</div>
          </div>
        ))}
        {rows?.length === 0 && <div className="empty">No audit entries yet</div>}
      </div>
    </div>
  )
}
